import { useEffect, useState } from 'react';
import { mediaUrl } from '../api/client';

/** Circular avatar: shows the player's photo when available, else their initial.
 *  ANTÉ: круг --brand-tint с инициалом Abhaya --brand; «свой»/лидер (solid) —
 *  сплошной --brand с белым инициалом. На синей шапке инициал-аватар
 *  становится белым кругом (см. .bhead .avatar в theme.css). */
type AvatarProps = {
  name?: string | null;
  /** Photo URL (Telegram or our /api/avatars/:id). Falls back to the initial. */
  src?: string | null;
  size?: number;
  /** kept for call-site compatibility; tint look is the same for the whole stack */
  variant?: number;
  bordered?: boolean;
  /** свой/лидер — сплошной синий круг с белым инициалом */
  solid?: boolean;
};

export function Avatar({ name, src, size = 42, bordered, solid }: AvatarProps) {
  const initial = (name || '?').trim().charAt(0).toUpperCase() || '?';

  const resolved = mediaUrl(src);
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [resolved]);

  return (
    <span
      className={`avatar${solid ? ' avatar--solid' : ''}${bordered ? ' avatar--bordered' : ''}`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.4) }}
    >
      {resolved && !failed ? (
        <img src={resolved} alt={name ?? ''} onError={() => setFailed(true)} />
      ) : (
        initial
      )}
    </span>
  );
}
